import ForwardTracker from "../../../../prop-trackers/forward-tracker.js";
import PropTracker from "../../../../prop-trackers/prop-tracker.js";
import ValueTracker from "../../../../prop-trackers/value-tracker.js";
import { Mapper, ValueMapper } from "../../../../prop-tracker-utils/mapper.js";

class CubeGeometryTrackerLoader extends ForwardTracker {
    constructor(geoDataTracker, evtCtx, cubeGeometryLoader, userdata) {
        const loadMapper = new Mapper(geoDataTracker, (key) => new SingleLoadMapper(evtCtx, cubeGeometryLoader), userdata);
        super(loadMapper);
    }
}

class SingleLoadMapper extends ValueMapper {
    constructor(evtCtx, cubeGeometryLoader) {
        super();

        this._evtCtx = evtCtx;
        this._cubeGeometryLoader = cubeGeometryLoader;

        this._paramsTracker = new PropTracker();
        this._geometry = null;
        this._valueTracker = new ValueTracker();

        this._paramsTracker.listenNeedsUpdate(() => this.protected_needsUpdate());
    }

    setValue(data) {
        const events = data ? this._evtCtx.getEvents(data) : null;
        this._paramsTracker.track(data, events);
    }

    deleteValue() {
        this._paramsTracker.track();
    }

    protected_startUpdate() {
        this._paramsTracker.updateIfNeeded(({ props }) => {
            const { newExists: widthSet, newValue: width } = props.get("width");
            const { newExists: heightSet, newValue: height } = props.get("height");
            const { newExists: depthSet, newValue: depth } = props.get("depth");

            if (this._geometry) {
                this._cubeGeometryLoader.unload(this._geometry);
            }

            if (widthSet && heightSet && depthSet) {
                this._geometry = this._cubeGeometryLoader.load(width, height, depth);
                this._valueTracker.setValue(this._geometry);
            } else {
                this._geometry = null;
                this._valueTracker.deleteValue();
            }
        });

        return this._valueTracker.startUpdate();
    }

    protected_finishUpdate() {
        this._valueTracker.finishUpdate();
    }
}

export default CubeGeometryTrackerLoader;
